import React, { useEffect, useState } from "react";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import GetAppRoundedIcon from "@material-ui/icons/GetAppRounded";
import { Tooltip } from "@material-ui/core";
import alderLogo from "../../../assets/img/alder-logo.png";
import {alderLogoUrl} from '../../../config/keys';
const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
    background: "transparent",
    borderColor: "transparent",
  },
}));
const DownloadOrderExcel = (props) => {
  const classes = useStyles();
  console.log("Download Order Excel");
  const orderData = props.order;
  let orderToDetails =
    props.order.orderType == "sales"
      ? props.order.partner
      : props.order.warehouse;
  console.log('orderToDetails');
  console.log(orderToDetails);
  let orderToName = orderToDetails?.name;
  let orderAddress = props.order.deliveryAddress;
  let orderToId = props.order.orderType == "sales" ? orderToDetails?.partner_barcode:orderToDetails?.warehouse_barcode;
  let orderDate = props.order.orderDate;
  let datearray = orderDate.split("-");
  let newDate = datearray[2] + "-" + datearray[1] + "-" + datearray[0];
  orderDate = newDate;
  let orderBarcode = props.order.order_barcode;
  orderBarcode = orderBarcode != "" ? orderBarcode.toString() : "";
  const isLoading = !orderData;
  const showData = orderData;
  const excelFilename = `order-invoice-${props.order.order_barcode}`;
  let totalAmount = 0;
  let totalGrossWeight = 0;
  let totalPkg = 0;
  let totalOrderQty = 0;
  let products = [];
  let pushedObjects = [];
  let total = 0;
  // let orderItems = [];
  // orderItems = [...props.order.allLoad];
  let orderItems = props.order.allLoad.map((item) => {
    return { ...item };
  });
  // console.log("Before For Each");
  // console.table("products");
  // console.table(products);
  // console.table("orderItems");
  // console.table(orderItems);
  // console.table("props order load");
  // console.table(props.order.allLoad);
  orderItems.forEach((val) => {
    // if(val.quantity > 1) {
    //     // this is just a temporary solution
    //         // for the issue of automatically change of product quantity value in props.order.allLoad
    //     console.log("pdf val.quantity");
    //     console.log(val.quantity);
    //     val.quantity = 1;
    //     console.log(val.quantity);
    // }
    let temp =
      val.price * val.quantity + (val.tax.gst / 100) * val.price * val.quantity;
    total += temp;

    totalAmount += temp - (temp / 100) * val.discount;
    let productId = val.item._id;
    if (pushedObjects.length > 0 && pushedObjects.includes(productId)) {
      //  console.log('id exist');
      var productIndex = products.findIndex(function (value) {
        return value.item._id == productId;
      });
      console.log("product index:" + productIndex);
      let currentQuantity = products[productIndex].quantity;
      products[productIndex].quantity = currentQuantity + 1;
    } else {
      // console.log('id not exist');
      pushedObjects.push(productId);
      products.push(val);
    }
  });
  totalAmount = Math.ceil(totalAmount);
  // console.log("temp", total);
  // console.log("dis", totalAmount);
  return (
    <React.Fragment>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button"
        table="table-to-xls"
        filename={excelFilename}
        sheet="order"
        buttonText={
          <Tooltip title="Download Excel">
            <Button
              variant="contained"
              color="default"
              className={classes.button}
              startIcon={<GetAppRoundedIcon />}
            >
              Download Excel
            </Button>
          </Tooltip>
        }
      />
      <Divider />
      <table id="table-to-xls" hidden border="1">
        <tbody >
          {/* <tr rowSpan="1" style={{backgroundColor:'#fff',borderBottom:"none",borderBottomColor:'#fff'}}></tr>   */}
          <tr rowSpan="4" style={{borderBottom:"none",borderBottomColor:'#fff'}}>
            <td
              colSpan="5"
              style={{marginLeft:'10%',textAlign: "center",
              
              borderRight:"none",
              borderBottom:"none",
              borderBottomColor:'#fff',
              backgroundColor:'#fff'}}
            >
              {/* ALDER
              <small style={{ marginLeft: 10, color: "#888888" }}>
                {" "}
                ISO 9001:2008 Certified
              </small> */}
              <div style={{height:10,color:'#fff'}}>a</div>
              {/* <span style={{display:'inline',width:"1%",color:'#fff'}}>a</span> */}
              <img  alt="alder logo" src={alderLogoUrl} style={{display:'inline'
              ,marginLeft: '1%',
              }} width="20%" height="10%" />
              
            </td>

            <td colSpan="6" style={{ textAlign: "right",borderLeft:"none",borderBottom:"none",backgroundColor:"#fff" }}>
              <p><br></br>
                ALDER FURNITURE PVT LTD<br></br>
                27 FURNITURE BLOCK, KIRTI NAGAR, NEW DELHI – 110015 (INDIA)<br></br>
                Website: www.alder.in, Email: info@alder.in | sales@alder.in<br></br>
                Phone: +91-011-42903322
              </p>
            </td>
          </tr>
          <tr style={{borderTop:"none",borderTopColor:'#fff'}}>
            <td colSpan="11" style={{borderTop:"none",borderTopColor:'#fff'}}>
            </td>
          </tr>
          <tr>
            <td colSpan="11" style={{ textAlign:"center", fontWeight: "bold"}}>PROFORMA INVOICE</td>
          </tr>
          <tr>
            <td colSpan="8" style={{ textAlign: "left", textTransform: "capitalize" }}>CLIENT ID:- &nbsp;{orderToId}</td>
            <td colSpan="3">PI NO. &nbsp;{"PI/"+(orderBarcode.substr(orderBarcode.length -5)) + ""}</td>
          </tr>
          <tr>
            <td colSpan="8" style={{ textAlign: "left", textTransform: "capitalize" }}>CLIENT NAME:- &nbsp;{orderToName}</td>
            <td colSpan="3">DISPATCH DATE: &nbsp;{orderDate}</td>
          </tr>
          <tr>
            <td colSpan="11" style={{ textAlign: "left", textTransform: "capitalize" }}>CLIENT ADDRESS:- &nbsp;{orderAddress}</td>
          </tr>
          {/* <tr>
            <td>Client ID</td>
            <td
              colSpan="2"
              style={{ textAlign: "right", textTransform: "capitalize" }}
            >
              {orderToName}
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>  */}
          {/* <tr>
            <td colSpan="11"></td>
          </tr> */}
          <tr>
            <td colSpan="11"></td>
          </tr>
          <tr>
            <th style={{ textDecoration: "underline" }}>Sl No</th>
            <th style={{ textDecoration: "underline" }}>Item Code</th>
            <th style={{ textDecoration: "underline" }}>Item Name</th>
            <th
              style={{
                textDecoration: "underline",
                backgroundColor: "#ffd5ff",
              }}
            >
              Order Quantity
            </th>
            <th
              style={{
                textDecoration: "underline",
                backgroundColor: "#f8cbad",
              }}
            >
              Number of Packages
            </th>
            <th
              style={{
                textDecoration: "underline",
                backgroundColor: "#ccecff",
              }}
            >
              Total Packages
            </th>
            <th
              style={{
                textDecoration: "underline",
                backgroundColor: "#ccecff",
              }}
            >
              Total Weight
            </th>
            {/* <th>Total CBM</th> */}
            <th
              style={{
                textDecoration: "underline",
                backgroundColor: "#ccecff",
              }}
            >
              Unit Price (INR)
            </th>
            <th
              style={{
                textDecoration: "underline",
              }}
            >
              Discount (%)
            </th>
            <th style={{ textDecoration: "underline" }}>Tax (%)</th>
            <th
              style={{
                textDecoration: "underline",
                backgroundColor: "#fce4d6",
              }}
            >
              Total Amount (INR)
            </th>
          </tr>
          {products.map((val, index) => {
            let totalWeight = 0;
            let totalCBM = 0;
            val.type == "Product" &&
              val.item &&
              val.item.productParts.map((part) => {
                totalWeight += parseInt(part.partId && part.partId.weight);
                totalCBM +=
                  part.partId &&
                  part.partId.height * part.partId &&
                  part.partId.width * part.partId &&
                  part.partId.length;
              });
            let totalAmount =
              val.price * val.quantity +
              (val.tax.gst / 100) * val.price * val.quantity;
            let totalAmountDis =
              totalAmount - (totalAmount / 100) * val.discount;
            totalAmountDis = Math.ceil(totalAmountDis);
            totalGrossWeight +=
              totalWeight > 0 ? totalWeight * val.quantity : 0;
            totalOrderQty += val.quantity;
            totalPkg +=
              val.type == "Product" && val.item
                ? val.item.productParts.length * val.quantity
                : 1 * val.quantity;
            return (
              <React.Fragment>
                {val.type == "Product" && val.item && val.item != null ? (
                  <tr>
                    <td style={{textAlign:'center'}}>{index + 1}</td>
                    <td style={{textAlign:'center'}}>&nbsp;{val.item && val.item.product_barcode}</td>
                    <td style={{textAlign:'left',fontWeight:'bold'}}>{val.item && val.item.productName}</td>
                    <td style={{textAlign:'center'}}>{val.quantity}</td>
                    <td style={{textAlign:'center'}}>{val.item && val.item.productParts.length}</td>
                    <td style={{textAlign:'center'}}>
                      {val.item && val.item.productParts.length * val.quantity}
                    </td>
                    <td style={{textAlign:'center'}}>{totalWeight > 0 ? totalWeight * val.quantity : ""}</td>
                    {/* <td>{totalCBM > 0  ? (totalCBM*val.quantity):''}</td> */}
                    <td style={{textAlign:'center'}}>{val.price}</td>
                    <td style={{textAlign:'center'}}>{val.discount} %</td>
                    <td style={{textAlign:'center'}}>{val.tax.gst}%</td>
                    <td style={{textAlign:'center'}}>{totalAmountDis}</td>
                  </tr>
                ) : (
                  <tr>
                    <td style={{textAlign:'center'}}>{index + 1}</td>
                    <td style={{textAlign:'center'}}>&nbsp;{val.item && val.item.parts_barcode}</td>
                    <td style={{textAlign:'left',fontWeight:'bold'}}>{val.item && val.item.partName}</td>
                    <td style={{textAlign:'center'}}>{val.quantity}</td>
                    <td style={{textAlign:'center'}}>1</td>
                    <td style={{textAlign:'center'}}>{val.quantity}</td>
                    <td style={{textAlign:'center'}}>
                      {val.item && val.item.weight > 0
                        ? Math.round(val.item.weight * val.quantity * 100) / 100
                        : ""}
                    </td>
                    {/* <td>
                      {val.item &&
                      val.item.height * val.item.width * val.item.length > 0
                        ? val.item.height *
                          val.item.width *
                          val.item.length *
                          val.quantity
                        : ""}
                    </td> */}
                    <td style={{textAlign:'center'}}>{Math.round(val.price)}</td>
                    <td style={{textAlign:'center'}}>{val.discount} %</td>
                    <td style={{textAlign:'center'}}>{val.tax.gst} %</td>
                    <td style={{textAlign:'center'}}>{Math.round(totalAmountDis * 100) / 100}</td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
          <tr>
            <td></td>
            <td></td>
            <td style={{ textAlign: "right" }}>Total Quantity</td>
            <td style={{ textAlign: "center" }}>{totalOrderQty}</td>
            <td></td>
            <td style={{ textAlign: "center" }}>{totalPkg}</td>
            <td style={{ textAlign: "center" }}>{totalGrossWeight}</td>
            <td></td>
            <td colSpan="2" style={{ textAlign: "right" }}>
              Total Amount
            </td>
            <td style={{ textAlign: "center" }}>
              {" "}
              Rs {Math.round(totalAmount)}
            </td>
          </tr>
        </tbody>
      </table>
    </React.Fragment>
  );
};

export default DownloadOrderExcel;
